import React from 'react';
import Navigation from '../components/Navigation';
import ContactSection from '../sections/ContactSection';
import Footer from '../components/Footer';
import { useAuraluxClientEffects } from '../hooks/useAuraluxClientEffects';

export default function Contact() {
  useAuraluxClientEffects();

  return (
    <>
      <Navigation />
      <ContactSection />
      <Footer />
    </>
  );
}
